import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'react-toastify/dist/ReactToastify.css';

if (process.env.NODE_ENV === 'production') {
  // Disable right-click context menu
  document.addEventListener('contextmenu', e => e.preventDefault());
  
  // Disable common keyboard shortcuts for developer tools
  document.addEventListener('keydown', e => {
    // F12
    if (e.key === "F12" || e.keyCode === 123) {
      e.preventDefault();
      return false;
    }

    // Windows/Linux shortcuts (Ctrl+Shift+I / J / C)
    if (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "J" || e.key === "C" || e.keyCode === 73 || e.keyCode === 74 || e.keyCode === 67)) {
      e.preventDefault();
      return false;
    }

    // Ctrl+U (View Source)
    if (e.ctrlKey && (e.key === "U" || e.keyCode === 85)) {
      e.preventDefault();
      return false;
    }

    // Mac specific shortcuts (Cmd+Option+I / Cmd+Option+J / Cmd+Option+C / Cmd+Option+U)
    if (e.metaKey && e.altKey && (e.key === "I" || e.key === "J" || e.key === "C" || e.key === "U" || e.keyCode === 73 || e.keyCode === 74 || e.keyCode === 67 || e.keyCode === 85)) {
      e.preventDefault();
      return false;
    }

    // Mac Cmd+Shift+C (Inspect Element)
    if (e.metaKey && e.shiftKey && (e.key === "C" || e.keyCode === 67)) {
      e.preventDefault();
      return false;
    }
  });

  // Anti-debugging loop (freezes the app if DevTools is open)
  const antiDebug = () => {
    try {
      const fn = new Function("debugger");
      fn();
    } catch (err) {
      // Ignore
    }
    setTimeout(antiDebug, 100);
  };
  antiDebug();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
